export function getToken() {

  // Hello friend
  // since you have gone through so much trouble to find this place
  // it is evident that your technical skills are high. 
  // Why not contact me and we can work together to make money?
  // hello@promptboom.com
  return 'contact_me_to_work_together_hello@promptboom.com'
}
